// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/download-to-excel/download-to-excel.scss';
import './index.scss';
import React, {PropTypes} from 'react';
import DownloadToExcelForPanel from '../../../../shared/components/download-to-excel-for-panel';
import {FormattedMessage} from 'react-intl';
import {Link} from 'react-router';
import User from '@deere/cps-it.warranty-model-factory/lib/user';
import Warranty from '@deere/cps-it.warranty-model-factory/lib/warranty';
import WarrantyCoverageItem from './warranty-coverage-item';
import {exportToExcel} from '../../../../shared/services/export-to-excel';

const WarrantyCoveragePanel = (props, context) => {

    const warrantyCoverageItems = props.warranties.map(warrantyCoverageItem =>
        <WarrantyCoverageItem
            key={warrantyCoverageItem.id + warrantyCoverageItem.warrantyItemText.replace(/ /g, '_')}
            maintenancePlanLink={props.maintenancePlanLink}
            onClick={props.onClick}
            showDisabledClass={props.showDisabledClass}
            warranty={warrantyCoverageItem}
        />
    );

    const downloadToExcelEl = (
        props.warranties.length ?
            (<div className={'button-panel'}>
                {props.showPartsCoverageSearchButton ?

                    <Link
                        className={'panel-header-button'}
                        to={`/claims/parts-coverage-search?pin=${props.pin}`}
                    >
                        <FormattedMessage id='PARTS_COVERAGE_SEARCH'/>
                    </Link> : null

                }
                <DownloadToExcelForPanel onDownload={() => exportToExcel(`/api/products/${props.pin}/warranties?export=EXCEL&language=${context.user.getLocale()}`)}/>
            </div>) : null);

    return (
        <section className='warranty-coverage-panel'>
            <header className='warranty-coverage-title'>
                <FormattedMessage id='WARRANTY_COVERAGE'/>
                {props.isSapUp && downloadToExcelEl}
            </header>
            {warrantyCoverageItems}
        </section>
    );

};

WarrantyCoveragePanel.displayName = 'WarrantyCoveragePanel';
WarrantyCoveragePanel.propTypes = {
    isSapUp: PropTypes.bool.isRequired,
    maintenancePlanLink: PropTypes.bool.isRequired,
    pin: PropTypes.string.isRequired,
    showDisabledClass: PropTypes.bool.isRequired,
    showPartsCoverageSearchButton: PropTypes.bool.isRequired,
    warranties: PropTypes.arrayOf(PropTypes.instanceOf(Warranty)).isRequired
};
WarrantyCoverageItem.defaultProps = {
    maintenancePlanLink: false
};
WarrantyCoveragePanel.contextTypes = {
    user: PropTypes.instanceOf(User).isRequired
};
WarrantyCoveragePanel.defaultProps = {
    showPartsCoverageSearchButton: false
};

export default WarrantyCoveragePanel;



// WEBPACK FOOTER //
// ./src/product/details/components/warranty-coverage-panel/index.js